/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRecoveringProductLineDto } from '../../models/create-recovering-product-line-dto';
import { RecoveringProductLine } from '../../models/recovering-product-line';

export interface CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params {
      body: CreateRecoveringProductLineDto
}

export function createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveringProductLine>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveringProductLine>;
    })
  );
}

createOneBaseMgmtRecoveringProductLineControllerRecoveringProductLine.PATH = '/api/mgmt/recovering-product-line';
